// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5ac4803c","453":"1e4ad6ac"}[chunkId] + ".chunk.js";
};